import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Select from 'Components/Atoms/Select/Select';
import Input from 'Components/Atoms/Input/Input';
import Checkbox from 'Components/Atoms/Checkbox/Checkbox';
import useCountries from 'Hooks/useCountries';

const getInvoiceDocTypes = (t) => [
    { value: null, label: t('tax-authority-config-all-option') },
    { value: 'F1', label: t('verifactu-invoice-type-f1') },
    { value: 'F2', label: t('verifactu-invoice-type-f2') },
    { value: 'F3', label: t('verifactu-invoice-type-f3') },
    { value: 'R1', label: t('verifactu-invoice-type-r1') },
    { value: 'R2', label: t('verifactu-invoice-type-r2') },
    { value: 'R3', label: t('verifactu-invoice-type-r3') },
    { value: 'R4', label: t('verifactu-invoice-type-r4') },
    { value: 'R5', label: t('verifactu-invoice-type-r5') },
];

const getIssuerTypeOptions = (t) => [
    { value: null, label: t('verifactu-issuer-type-direct') },
    { value: 'T', label: t('verifactu-issuer-type-third-party') },
    { value: 'D', label: t('verifactu-issuer-type-self-invoice') },
];

const getRegimeOptions = (t) => [
    { value: '01', label: t('verifactu-vat-regime-01') },
    { value: '02', label: t('verifactu-vat-regime-02') },
    { value: '03', label: t('verifactu-vat-regime-03') },
    { value: '04', label: t('verifactu-vat-regime-04') },
    { value: '05', label: t('verifactu-vat-regime-05') },
    { value: '06', label: t('verifactu-vat-regime-06') },
    { value: '07', label: t('verifactu-vat-regime-07') },
    { value: '08', label: t('verifactu-vat-regime-08') },
    { value: '09', label: t('verifactu-vat-regime-09') },
    { value: '10', label: t('verifactu-vat-regime-10') },
    { value: '11', label: t('verifactu-vat-regime-11') },
    { value: '14', label: t('verifactu-vat-regime-14') },
    { value: '15', label: t('verifactu-vat-regime-15') },
    { value: '17', label: t('verifactu-vat-regime-17') },
    { value: '18', label: t('verifactu-vat-regime-18') },
    { value: '19', label: t('verifactu-vat-regime-19') },
    { value: '20', label: t('verifactu-vat-regime-20') },
];

export default function ContactEditorDrawerDefaultValuesFormVerifactu({ values, onChangeValue }) {
    const { t } = useTranslation('invoices');
    const { countries } = useCountries();

    const countriesOptions = [
        { value: null, label: t('tax-authority-config-all-option') },
        ...(countries ?? [])
            .map((c) => ({ value: c.code, label: c.name }))
            .sort((a, b) => a.label.localeCompare(b.label)),
    ];

    const showRepresentative = values.es_verifactu_issuer_type === 'T';

    return (
        <div className="grid gap-6 pt-5">
            <Select
                className="w-full"
                value={values.es_verifactu_doc_type}
                onChange={(value) => onChangeValue({ es_verifactu_doc_type: value })}
                label={t('verifactu-invoice-type-label')}
                options={getInvoiceDocTypes(t)}
            />
            <Select
                className="w-full"
                value={values.es_verifactu_regime}
                onChange={(value) => onChangeValue({ es_verifactu_regime: value })}
                label={t('tax-authority-config-regime-label')}
                options={getRegimeOptions(t)}
            />
            <Select
                className="w-full"
                value={values.es_verifactu_issuer_type}
                onChange={(value) => onChangeValue({ es_verifactu_issuer_type: value })}
                label={t('verifactu-issuer-type-label')}
                options={getIssuerTypeOptions(t)}
            />
            {showRepresentative && (
                <>
                    <Input
                        value={values.representative_name ?? ''}
                        onChange={(e) => onChangeValue({ representative_name: e.target.value })}
                        label={t('verifactu-representative-name-label')}
                        placeholder={t('verifactu-representative-name-placeholder')}
                    />
                    <Input
                        value={values.representative_tax_id ?? ''}
                        onChange={(e) => onChangeValue({ representative_tax_id: e.target.value })}
                        label={t('verifactu-representative-tax-id-label')}
                        placeholder={t('verifactu-representative-tax-id-placeholder')}
                    />
                    <Select
                        className="w-full"
                        value={values.representative_country}
                        onChange={(value) => onChangeValue({ representative_country: value })}
                        label={t('verifactu-representative-country-label')}
                        options={countriesOptions}
                        enableFilter
                    />
                </>
            )}
            <Checkbox
                checked={values.es_verifactu_simplified_art7273 === 'S'}
                onChange={(e) => onChangeValue({ es_verifactu_simplified_art7273: e.target.checked ? 'S' : 'N' })}
            >
                <span className="text-sm">{t('verifactu-simplified-with-client-data-label')}</span>
            </Checkbox>
        </div>
    );
}

ContactEditorDrawerDefaultValuesFormVerifactu.propTypes = {
    values: PropTypes.object.isRequired,
    onChangeValue: PropTypes.func.isRequired,
};
